import { useReveal } from "../../../../hooks/useReveal";
import styles from "./TalentsWhy.module.css";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const whyItems = [
  {
    title: "Anti-fake-employer",
    body: "No fees, ever. Every employer is verified before they can post a role here.",
  },
  {
    title: "Stand out beyond your CV",
    body: "Show real ability through verified assessments — not just job titles and schools.",
  },
  {
    title: "Get discovered by real companies",
    body: "Hiring teams across Africa actively search for talent on Awasource — every day.",
  },
  {
    title: "Understand your strengths with AI",
    body: "Detailed insights on how you think, communicate, and where you outperform.",
  },
  {
    title: "Improve faster with personalized feedback",
    body: "Specific, actionable recommendations that compound — not generic course suggestions.",
  },
  {
    title: "No connections needed",
    body: "Your ability speaks for itself. We level the playing field for talent everywhere.",
  },
];

const skillPills = [
  { label: "User Research", variant: "green" },
  { label: "Design Systems", variant: "green" },
  { label: "Prototyping", variant: "default" },
  { label: "Stakeholder Comms", variant: "amber" },
];

function WhyItem({ title, body }) {
  const { ref, isVisible } = useReveal();
  return (
    <li
      ref={ref}
      className={`${styles.item} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <span className={styles.check}>
        <CheckIcon />
      </span>
      <div>
        <h4>{title}</h4>
        <p>{body}</p>
      </div>
    </li>
  );
}

export default function TalentsWhy() {
  return (
    <section className={styles.section} id="why">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Why Awasource</span>
          <h2 className={styles.h2}>Why talents choose Awasource</h2>
          <p className={styles.sub}>
            A platform built for the way you actually work — not the way HR
            forms ask you to describe it.
          </p>
        </div>

        <div className={styles.grid}>
          {/* Checklist */}
          <ul className={styles.list}>
            {whyItems.map((item) => (
              <WhyItem key={item.title} {...item} />
            ))}
          </ul>

          {/* Dark profile card */}
          <div className={styles.visual}>
            <h5>Talent profile</h5>
            <div className={styles.bigName}>Adaeze O.</div>
            <div className={styles.meta}>
              Product Designer · 3 yrs · Lagos, Nigeria
            </div>

            <div className={styles.pillsLabel}>Verified strengths</div>
            <div className={styles.pills}>
              {skillPills.map((pill) => (
                <span
                  key={pill.label}
                  className={`${styles.pill} ${
                    pill.variant === "green"
                      ? styles.pillGreen
                      : pill.variant === "amber"
                        ? styles.pillAmber
                        : ""
                  }`}
                >
                  <span className={styles.pillDot} />
                  {pill.label}
                </span>
              ))}
            </div>

            <div className={styles.verified}>
              ✓ Skills verified by Awasource AI
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
